(function () {
  var root = document.querySelector('[data-cfg]');
  if (!root) return;

  var MODELS = JSON.parse(root.querySelector('[data-cfg-models]').textContent);
  var STEPS = ['Modell', 'Fahrzeug', 'Grösse', 'Oberfläche', 'Details', 'Übersicht'];
  var COLORS = [
    { id: 'silver', name: 'Hypersilber', hex: '#C9C4B8', f: 'none' },
    { id: 'white', name: 'Alpinweiss', hex: '#E6E1D5', f: 'grayscale(1) brightness(1.18) contrast(0.9)' },
    { id: 'titan', name: 'Titan', hex: '#9C9A94', f: 'grayscale(1) brightness(0.82)' },
    { id: 'graphite', name: 'Graphit', hex: '#4A4844', f: 'grayscale(1) brightness(0.55) contrast(1.15)' },
    { id: 'black', name: 'Schwarz', hex: '#232221', f: 'grayscale(1) brightness(0.32) contrast(1.35)' },
    { id: 'gold', name: 'Hirsch-Gold', hex: '#B49455', f: 'grayscale(1) sepia(1) saturate(1.6) brightness(0.95)' },
    { id: 'bronze', name: 'Bronze', hex: '#8C6B3E', f: 'grayscale(1) sepia(1) saturate(1.3) brightness(0.7) hue-rotate(-8deg)' },
    { id: 'oxblood', name: 'Ochsenblut', hex: '#6B2A26', f: 'grayscale(1) sepia(1) saturate(2.4) hue-rotate(-38deg) brightness(0.55)' }
  ];
  var BRANDS = ['Porsche', 'Ferrari', 'Lamborghini', 'McLaren', 'Mercedes-AMG', 'BMW M', 'Audi Sport', 'Aston Martin', 'Andere'];
  var USES = ['Strasse', 'Strasse und Track', 'Rennserie'];
  var SIZES = [19, 20, 21, 22];
  var WIDTHS = ['8.5J', '9J', '10J', '11J', '12J'];
  var CONC = ['Flach', 'Mittel', 'Tief'];
  var FINISHES = ['Glänzend', 'Seidenmatt', 'Gebürstet', 'Poliert'];
  var MATS = ['Geschmiedetes Aluminium', 'Geschmiedetes Magnesium'];
  var CAPS = ['Gold-Hirsch auf Schwarz', 'Hirsch auf Rot', 'Silber-Hirsch', 'Individuell'];
  var CAP_PRESETS = [
    { name: 'Rennrot', hex: '#B3121B' }, { name: 'British Racing Green', hex: '#0F3D2E' },
    { name: 'Königsblau', hex: '#1C3F94' }, { name: 'Signalorange', hex: '#E5671F' },
    { name: 'Alpinweiss', hex: '#EDEAE2' }, { name: 'Hirsch-Gold', hex: '#C29A4E' }
  ];
  var BOLTS = ['Titan', 'Gold', 'Schwarz'];
  var CERTS = ['Mit Schweizer Zertifikat', 'Ohne Schweizer Zertifikat'];
  var swapTok = 0;
  var CATS = { '1': '1-Piece', '2': '2-Piece', '3': '3-Piece' };
  var INSET = { 19: 13, 20: 11, 21: 9, 22: 7 };

  var s = {
    step: 0, model: 0, cat: 'all', brand: '', carModel: '', use: USES[0], size: 20, wf: '9J', wr: '11J', conc: 'Mittel',
    color: MODELS.length ? MODELS[0].native : 'bronze', finish: 'Poliert', material: MATS[0],
    cap: CAPS[0], capColor: '#B3121B', bolts: 'Titan', engraving: '', cert: '',
    visited: [false, false, false, false, false, false]
  };

  // Fahrzeug aus dem Fitment-Finder vorbelegen (?make=&model=&variant=)
  try {
    var q = new URLSearchParams(window.location.search);
    if (q.get('make')) {
      s.brand = q.get('make');
      if (BRANDS.indexOf(s.brand) === -1) BRANDS.unshift(s.brand);
      s.carModel = [q.get('model'), q.get('variant')].filter(Boolean).join(', ');
    }
    // Modell vorwählen (?modell=HF2 oder ?modell=2), z. B. aus "Serie 1" auf der Startseite
    var wanted = q.get('modell');
    if (wanted) {
      var w0 = wanted.toLowerCase().trim();
      var hit = MODELS.findIndex(function (m) { return m.name.toLowerCase() === w0; });
      if (hit === -1) hit = MODELS.findIndex(function (m) { return m.name.toLowerCase().indexOf(w0) === 0; });
      if (hit === -1 && /^\d+$/.test(wanted)) hit = Number(wanted) - 1;
      if (hit >= 0 && hit < MODELS.length) { s.model = hit; s.color = MODELS[hit].native; s.material = MODELS[hit].mag ? MATS[1] : MATS[0]; }
    }
  } catch (err) { /* ohne Vorbelegung weiter */ }

  var $ = function (sel) { return root.querySelector(sel); };
  var esc = function (v) {
    return String(v).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var colorOf = function (id) { return COLORS.filter(function (c) { return c.id === id; })[0] || COLORS[0]; };
  var model = function () { return MODELS[s.model] || { name: 'Modell', sub: '', img: '', native: 'bronze', mag: false }; };

  function pills(key, list, fmt) {
    return '<div class="cfg__pills">' + list.map(function (v) {
      return '<button type="button" data-set="' + key + '" data-val="' + esc(v) + '" aria-pressed="' + (String(s[key]) === String(v)) + '">' + esc(fmt ? fmt(v) : v) + '</button>';
    }).join('') + '</div>';
  }
  function group(label, body, hint) {
    return '<div class="cfg__group"><div class="cfg__label">' + label + '</div>' + body + (hint ? '<p class="cfg__hint">' + hint + '</p>' : '') + '</div>';
  }
  function field(id, label, input) {
    return '<div class="cfg__in"><label class="cfg__label" for="' + id + '">' + label + '</label>' + input + '</div>';
  }

  var PANELS = [
    function () {
      var tabs = '<div class="cfg__tabs" role="group" aria-label="Bauart">' + [['all', 'Alle'], ['1', '1-Piece'], ['2', '2-Piece'], ['3', '3-Piece']].map(function (t) {
        return '<button type="button" data-cat="' + t[0] + '" aria-pressed="' + (s.cat === t[0]) + '">' + t[1] + '</button>';
      }).join('') + '</div>';
      var cards = MODELS.map(function (m, i) {
        if (s.cat !== 'all' && String(m.cat) !== s.cat) return '';
        return '<button type="button" class="cfg__model-btn" data-model="' + i + '" aria-pressed="' + (i === s.model) + '">' +
          '<img src="' + esc(m.img) + '" alt="" width="400" height="400" loading="lazy"><span><b>' + esc(m.name) + '</b><small>' + esc(m.sub) + '</small><em class="cfg__badge">' + CATS[m.cat] + '</em></span></button>';
      }).join('');
      return '<div class="cfg__stack"><h2 class="cfg__h">Wählen Sie <em>Ihr</em> Modell.</h2>' + tabs +
        (cards ? '<div class="cfg__slider"><button type="button" class="cfg__arrow cfg__arrow--prev" data-slide="-1" aria-label="Vorheriges Modell">‹</button><div class="cfg__models" data-slider>' + cards + '</div><button type="button" class="cfg__arrow cfg__arrow--next" data-slide="1" aria-label="Nächstes Modell">›</button></div>' : '<p class="cfg__hint">In dieser Bauart ist noch kein Modell hinterlegt.</p>') + '</div>';
    },
    function () {
      var opts = '<option value="">Bitte wählen</option>' + BRANDS.map(function (b) {
        return '<option' + (b === s.brand ? ' selected' : '') + '>' + esc(b) + '</option>';
      }).join('');
      return '<div class="cfg__stack"><h2 class="cfg__h">Für <em>welches</em> Fahrzeug?</h2>' +
        field('k-brand', 'Marke *', '<select id="k-brand" data-text="brand">' + opts + '</select>') +
        field('k-model', 'Modell und Baujahr *', '<input id="k-model" type="text" data-text="carModel" value="' + esc(s.carModel) + '" placeholder="z. B. 911 GT3, 2023">') +
        group('Einsatz', pills('use', USES)) +
        group('Schweizer Zertifikat *', pills('cert', CERTS)) +
        '<p class="cfg__hint cfg__hint--rule">Lochkreis, Mittenbohrung und Einpresstiefe bestätigen wir bei der Vermessung an Ihrem Fahrzeug. * Pflichtangaben, um fortzufahren (Marke, Modell, Zertifikat).</p></div>';
    },
    function () {
      return '<div class="cfg__stack"><h2 class="cfg__h">Grösse <em>und</em> Stance.</h2>' +
        group('Durchmesser', pills('size', SIZES, function (z) { return z + '″'; })) +
        group('Breite vorne', pills('wf', WIDTHS)) +
        group('Breite hinten', pills('wr', WIDTHS)) +
        group('Konkavität', pills('conc', CONC), 'Wird pro Achse auf Ihre Einpresstiefe gezeichnet.') + '</div>';
    },
    function () {
      var sw = '<div class="cfg__swatches">' + COLORS.map(function (c) {
        return '<button type="button" data-set="color" data-val="' + c.id + '" aria-pressed="' + (s.color === c.id) + '" aria-label="' + esc(c.name) + '" title="' + esc(c.name) + '"><span style="background:' + c.hex + '"></span></button>';
      }).join('') + '</div>';
      return '<div class="cfg__stack"><h2 class="cfg__h">Farbe <em>und</em> Oberfläche.</h2>' +
        group('Farbe — ' + esc(colorOf(s.color).name), sw) +
        group('Oberfläche', pills('finish', FINISHES)) +
        group('Material', pills('material', MATS)) + '</div>';
    },
    function () {
      var custom = '';
      if (s.cap === 'Individuell') {
        custom = '<div class="cfg__cap"><div class="cfg__cap-row"><div class="cfg__cap-dot" style="background:' + esc(s.capColor) + '"></div>' +
          '<div class="cfg__in"><label class="cfg__label" for="cap-color">Wunschfarbe</label><div style="display:flex;align-items:center;gap:10px">' +
          '<input id="cap-color" type="color" data-text="capColor" value="' + esc(s.capColor) + '"><span>' + esc(s.capColor.toUpperCase()) + '</span></div></div></div>' +
          '<div class="cfg__swatches">' + CAP_PRESETS.map(function (c) {
            return '<button type="button" data-set="capColor" data-val="' + c.hex + '" aria-pressed="' + (c.hex.toLowerCase() === s.capColor.toLowerCase()) + '" aria-label="' + esc(c.name) + '" title="' + esc(c.name) + '"><span style="background:' + c.hex + '"></span></button>';
          }).join('') + '</div><p class="cfg__hint">Der Farbton wird bei der Bemusterung nach RAL oder Ihrem Muster exakt abgestimmt.</p></div>';
      }
      return '<div class="cfg__stack"><h2 class="cfg__h">Die <em>Details.</em></h2>' +
        group('Nabenkappe', pills('cap', CAPS) + custom) +
        group('Montageschrauben', pills('bolts', BOLTS), 'Nur bei mehrteiligen Felgen sichtbar.') +
        field('k-eng', 'Gravur im Felgenhorn', '<input id="k-eng" type="text" maxlength="16" data-text="engraving" value="' + esc(s.engraving) + '" placeholder="Initialen oder Datum, max. 16 Zeichen">') + '</div>';
    }
  ];

  function rows() {
    var m = model(), c = colorOf(s.color);
    return [
      ['Modell', m.name],
      ['Bauart', CATS[m.cat] || '—'],
      ['Fahrzeug', ((s.brand || '[Marke]') + ' ' + s.carModel).trim()],
      ['Einsatz', s.use],
      ['Schweizer Zertifikat', s.cert || '—'],
      ['Durchmesser', s.size + '″'],
      ['Breite', 'vorne ' + s.wf + ' · hinten ' + s.wr],
      ['Konkavität', s.conc],
      ['Farbe', c.name + ' · ' + s.finish],
      ['Material', s.material],
      ['Nabenkappe', s.cap === 'Individuell' ? 'Individuell · ' + s.capColor.toUpperCase() : s.cap],
      ['Schrauben', s.bolts],
      ['Gravur', s.engraving || '—']
    ];
  }

  function filterFor() {
    var m = model(), c = colorOf(s.color);
    var f = c.id === m.native ? 'none' : c.f;
    if (s.finish === 'Seidenmatt') f = (f === 'none' ? '' : f + ' ') + 'contrast(0.88) brightness(0.96)';
    else if (s.finish === 'Gebürstet') f = (f === 'none' ? '' : f + ' ') + 'contrast(0.94)';
    else if (s.finish === 'Glänzend') f = (f === 'none' ? '' : f + ' ') + 'contrast(1.08) saturate(1.05)';
    return f || 'none';
  }

  function drawRing() {
    var out = '<circle r="117" fill="none" stroke="#C29A4E" stroke-opacity="0.55" stroke-width="0.4"/><circle r="106" fill="none" stroke="#3a372f" stroke-width="0.4"/>';
    for (var i = 0; i < 120; i++) {
      var a = i * Math.PI * 2 / 120, major = i % 10 === 0;
      var r2 = major ? 111 : 115;
      out += '<line x1="' + (117 * Math.sin(a)).toFixed(2) + '" y1="' + (-117 * Math.cos(a)).toFixed(2) + '" x2="' + (r2 * Math.sin(a)).toFixed(2) + '" y2="' + (-r2 * Math.cos(a)).toFixed(2) + '" stroke="' + (major ? '#C29A4E' : '#6a655c') + '" stroke-width="' + (major ? 0.7 : 0.4) + '"/>';
    }
    $('[data-ring]').innerHTML = out;
  }

  // Ein Schritt ist gültig, wenn seine Pflichtangaben vorhanden sind
  function valid(i) {
    if (i === 1) return !!(s.brand && String(s.carModel).trim() && s.cert);
    return true;
  }
  // Schritt gilt als erledigt, wenn er mit "Weiter" bestätigt wurde und noch gültig ist
  function isDone(i) { return !!s.visited[i] && valid(i); }
  // Höchster erreichbarer Schritt: der erste noch nicht erledigte
  function reach() {
    for (var i = 0; i < 5; i++) { if (!isDone(i)) return i; }
    return 5;
  }

  function renderSteps() {
    var max = reach();
    $('[data-steps]').innerHTML = STEPS.map(function (l, i) {
      var cls = i === s.step ? '' : (isDone(i) ? 'is-done' : 'is-todo');
      var locked = i > max;
      return '<button type="button" data-go="' + i + '" aria-label="Schritt 0' + (i + 1) + ': ' + l + (isDone(i) ? ' (erledigt)' : '') + '"' +
        (i === s.step ? ' aria-current="step"' : '') + (locked ? ' disabled' : '') + (cls ? ' class="' + cls + '"' : '') +
        '><span>0' + (i + 1) + '</span><span class="cfg__slabel">' + l + '</span></button>';
    }).join('');
  }

  function updateNext() {
    var next = $('[data-next]');
    var ok = valid(s.step);
    next.disabled = !ok;
    next.title = ok ? '' : 'Bitte zuerst die Pflichtangaben ausfüllen';
  }

  function render() {
    var m = model(), c = colorOf(s.color), last = s.step === 5;

    renderSteps();

    $('[data-progress-label]').innerHTML = '<span class="cfg__lab-d">Schritt ' + (s.step + 1) + ' von 6</span><span class="cfg__lab-m"><span class="cfg__gold">0' + (s.step + 1) + '</span> / 06</span>';
    $('[data-progress]').style.width = Math.round((s.step + 1) / 6 * 100) + '%';

    var panel = $('[data-panel]'), fin = $('[data-final]');
    panel.hidden = last; fin.hidden = !last;
    if (!last) {
      var curSlider = panel.querySelector('[data-slider]');
      if (curSlider && s.step === 0 && panel.getAttribute('data-sig') === 'm:' + s.cat) {
        // Nur Auswahl aktualisieren und sanft zentrieren, Slider nicht neu aufbauen (kein Ruckeln)
        Array.prototype.forEach.call(curSlider.querySelectorAll('.cfg__model-btn'), function (card) {
          card.setAttribute('aria-pressed', String(Number(card.getAttribute('data-model')) === s.model));
        });
        var picked = curSlider.querySelector('[aria-pressed="true"]');
        if (picked) {
          var to = picked.offsetLeft - (curSlider.clientWidth - picked.offsetWidth) / 2;
          if (Math.abs(curSlider.scrollLeft - to) > 2) curSlider.scrollTo({ left: to, behavior: 'smooth' });
        }
      } else {
        panel.innerHTML = PANELS[s.step]();
        panel.setAttribute('data-sig', s.step === 0 ? 'm:' + s.cat : 's:' + s.step);
        var newSlider = panel.querySelector('[data-slider]');
        if (newSlider) {
          var sel = newSlider.querySelector('[aria-pressed="true"]') || newSlider.querySelector('.cfg__model-btn');
          newSlider.style.scrollBehavior = 'auto';
          if (sel) newSlider.scrollLeft = sel.offsetLeft - (newSlider.clientWidth - sel.offsetWidth) / 2;
          newSlider.style.scrollBehavior = '';
          bindSlider(newSlider);
        }
      }
    }

    $('[data-back]').disabled = s.step === 0;
    var next = $('[data-next]');
    next.hidden = last;
    updateNext();
    next.innerHTML = 'Weiter<span class="cfg__long"> — ' + STEPS[Math.min(s.step + 1, 5)] + '</span>';

    $('[data-p-model]').textContent = m.name;
    $('[data-p-dim]').textContent = s.size + '″ · ' + (s.wf === s.wr ? s.wf + ' rundum' : s.wf + ' / ' + s.wr);
    $('[data-p-dim-m]').textContent = s.size + '″ · ' + c.name;
    var img = $('[data-p-img]');
    var wrap = $('[data-p-img-wrap]');
    if (img.getAttribute('src') !== m.img) {
      if (!img.getAttribute('src')) {
        img.src = m.img;
      } else {
        // Modellwechsel: Bild vorladen, dann Überblendung (altes Bild blendet aus, neues ein)
        var tok = ++swapTok, want = m.img, pre = new Image();
        var ghost = $('[data-p-ghost]'), oldSrc = img.getAttribute('src'), oldFilter = img.style.filter;
        pre.onload = pre.onerror = function () {
          if (tok !== swapTok) return;
          if (ghost) {
            ghost.src = oldSrc;
            ghost.style.filter = oldFilter;
            ghost.classList.remove('is-out');
            void ghost.offsetWidth;
            ghost.classList.add('is-out');
          }
          img.src = want;
          img.classList.remove('is-in');
          void img.offsetWidth;
          img.classList.add('is-in');
        };
        pre.src = want;
      }
    }
    img.alt = m.name + ', konfiguriert';
    img.style.filter = filterFor();
    // Grösse (19–22″) sofort sichtbar, ohne Animation; alle Felgenbilder haben gleichen Durchmesser
    wrap.style.transform = 'scale(' + (1 - 2 * INSET[s.size] / 100) + ')';
    $('[data-p-color]').textContent = c.name;
    $('[data-p-finish]').textContent = s.finish;
    $('[data-p-material]').textContent = s.material;

    var ref = refOf();
    $('[data-ref]').textContent = ref;
    $('[data-brief]').textContent = m.name + ' · ' + s.size + '″ · ' + c.name + ' · ' + s.finish;
    $('[data-summary]').innerHTML = rows().map(function (r) { return '<dt>' + esc(r[0]) + '</dt><dd>' + esc(r[1]) + '</dd>'; }).join('');
    syncForm(ref);
    panel.classList.toggle('is-slider', s.step === 0);
    updateArrows();
    alignSlider();
  }

  // Pfeile nur zeigen, wenn in der Richtung noch ein Modell folgt
  function updateArrows() {
    var sl = $('[data-slider]');
    if (!sl) return;
    var cards = Array.prototype.slice.call(sl.querySelectorAll('.cfg__model-btn'));
    var at = cards.findIndex(function (c) { return c.getAttribute('aria-pressed') === 'true'; });
    if (at < 0) at = 0;
    var prev = $('.cfg__arrow--prev'), next = $('.cfg__arrow--next');
    if (prev) prev.hidden = at <= 0;
    if (next) next.hidden = at >= cards.length - 1;
  }

  // Desktop: Felge im Slider auf dieselbe Mittellinie wie die Vorschau links bringen
  function alignSlider() {
    var sl = $('.cfg__slider'), img = sl && sl.querySelector('.cfg__model-btn img'), wheel = $('.cfg__wheel');
    if (!sl) return;
    sl.style.transform = '';
    if (!img || !wheel || !window.matchMedia('(min-width: 701px)').matches) return;
    var w = wheel.getBoundingClientRect(), i = img.getBoundingClientRect();
    var d = (w.top + w.height / 2) - (i.top + i.height / 2);
    sl.style.transform = 'translateY(' + Math.round(d) + 'px)';
  }

  function refOf() {
    return 'HW-' + (s.model + 1) + '-' + s.size + '-' + colorOf(s.color).id.slice(0, 2).toUpperCase() + (s.engraving ? '-G' : '');
  }

  function syncForm(ref) {
    var text = 'Zertifikat ' + (ref || refOf()) + '\n' + rows().map(function (r) { return r[0] + ': ' + r[1]; }).join('\n');
    $('[data-out-config]').value = text;
    $('[data-out-body]').value = 'Konfigurator-Anfrage\n\n' + text;
  }

  // Zentrierte Karte wird automatisch gewählt
  function bindSlider(sl) {
    var timer;
    sl.addEventListener('scroll', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var mid = sl.scrollLeft + sl.clientWidth / 2, best = null, bd = 1e9;
        Array.prototype.forEach.call(sl.querySelectorAll('.cfg__model-btn'), function (c) {
          var d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - mid);
          if (d < bd) { bd = d; best = c; }
        });
        if (best) {
          var idx = Number(best.getAttribute('data-model'));
          if (idx !== s.model) { s.model = idx; s.color = model().native; s.material = model().mag ? MATS[1] : MATS[0]; render(); }
        }
      }, 140);
    });
  }

  // Auswahl
  root.addEventListener('click', function (e) {
    var arrow = e.target.closest('[data-slide]');
    if (arrow && root.contains(arrow)) {
      var sl = $('[data-slider]'), card = sl && sl.querySelector('.cfg__model-btn');
      if (sl && card) sl.scrollBy({ left: Number(arrow.getAttribute('data-slide')) * (card.offsetWidth + 14), behavior: 'smooth' });
      return;
    }
    var t = e.target.closest('[data-set],[data-model],[data-go],[data-back],[data-next],[data-cat]');
    if (!t || !root.contains(t)) return;
    if (t.hasAttribute('data-cat')) {
      s.cat = t.getAttribute('data-cat');
      // Ist das gewählte Modell nicht in dieser Bauart, wird das erste passende aktiv
      var inCat = [];
      MODELS.forEach(function (m, i) { if (s.cat === 'all' || String(m.cat) === s.cat) inCat.push(i); });
      if (inCat.length && inCat.indexOf(s.model) === -1) {
        s.model = inCat[0];
        s.color = model().native;
        s.material = model().mag ? MATS[1] : MATS[0];
      }
    } else if (t.hasAttribute('data-set')) {
      var key = t.getAttribute('data-set'), val = t.getAttribute('data-val');
      s[key] = (key === 'size') ? Number(val) : val;
    } else if (t.hasAttribute('data-model')) {
      s.model = Number(t.getAttribute('data-model'));
      s.color = model().native;
      s.material = model().mag ? MATS[1] : MATS[0];
    } else if (t.hasAttribute('data-go')) {
      var target = Number(t.getAttribute('data-go'));
      if (target > reach()) return;
      s.step = target;
    } else if (t.hasAttribute('data-back')) {
      s.step = Math.max(0, s.step - 1);
    } else if (t.hasAttribute('data-next')) {
      if (!valid(s.step)) return;
      s.visited[s.step] = true;
      s.step = Math.min(5, s.step + 1);
    }
    render();
  });

  // Texteingaben ohne Neuzeichnen (Fokus bleibt erhalten)
  root.addEventListener('input', function (e) {
    var k = e.target.getAttribute && e.target.getAttribute('data-text');
    if (!k) return;
    s[k] = k === 'engraving' ? e.target.value.slice(0, 16) : e.target.value;
    if (k === 'capColor') { var dot = $('.cfg__cap-dot'); if (dot) dot.style.background = s.capColor; }
    $('[data-p-dim]').textContent = s.size + '″ · ' + (s.wf === s.wr ? s.wf + ' rundum' : s.wf + ' / ' + s.wr);
    syncForm();
    renderSteps();
    updateNext();
  });

  // Alle Schritte gleich hoch: höchsten Schritt messen und als Mindesthöhe setzen
  function equalize() {
    var panel = $('[data-panel]'), fin = $('[data-final]');
    var keep = s.step, max = 0;
    panel.style.minHeight = fin.style.minHeight = '';
    // Desktop: Konfigurator füllt die sichtbare Höhe unterhalb der Kopfzeile (siehe configurator-desktop.css)
    root.style.setProperty('--cfg-top', Math.max(0, root.getBoundingClientRect().top + window.pageYOffset) + 'px');
    if (window.matchMedia('(min-width: 701px)').matches) { render(); return; }
    panel.hidden = false; fin.hidden = true;
    for (var i = 0; i < PANELS.length; i++) {
      panel.innerHTML = PANELS[i]();
      max = Math.max(max, panel.offsetHeight);
    }
    panel.hidden = true; fin.hidden = false;
    max = Math.max(max, fin.offsetHeight);
    panel.style.minHeight = fin.style.minHeight = max + 'px';
    s.step = keep;
    render();
  }
  var eqTimer;
  window.addEventListener('resize', function () { clearTimeout(eqTimer); eqTimer = setTimeout(equalize, 200); });
  window.addEventListener('load', function () { equalize(); alignSlider(); });

  drawRing();
  if (root.querySelector('[data-posted]')) { s.step = 5; s.visited = [true, true, true, true, true, true]; }
  render();
  equalize();
})();
